import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, MessageCircle, Linkedin, Send } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_precision-vision/artifacts/6nho0zr1_TV%20Logo%20New_Final.png" 
                alt="Total Vision Logo" 
                className="h-16 w-auto mb-3 bg-white rounded-lg p-2"
              />
            </div>
            <p className="text-slate-400 text-sm mb-4">
              Total Vision Oil and Gas Fields Services and Consultancy LLC - SPC. We Engineer, We Manage, You Inspire. Leading the way in project management services for the oil & gas industry.
            </p>
            <div className="flex gap-3">
              <a
                href="https://wa.me/971523741221"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#25D366] hover:bg-[#20BA5A] rounded-lg flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#0A66C2] hover:bg-[#004182] rounded-lg flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/services/pre-award" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Pre-Award Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/post-award" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Post-Award Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/engineering" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Engineering Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/construction" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Construction Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/quality-management" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Quality Management Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/professional-enrichment" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Professional Enrichment
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/supply-chain" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Supply Chain Management
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <a
                  href="https://www.google.com/maps/place/Total+Vision+Oil+%26+Gas+Fields+Services+%26+Consultancy+LLC/@24.497278,54.374746,12z/data=!4m6!3m5!1s0x3e5e43bbdc93c851:0x6ecc4c068bac796f!8m2!3d24.4972782!4d54.3747465!16s%2Fg%2F11trq6bfhc?hl=en-US&entry=ttu&g_ep=EgoyMDI2MDIxNy4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Ahmed Ghanem Mazroui Building, Office No. 1001, 10th Floor, Hamdan Bin Mohammed Street, Al Zahiyah – E15 – Abu Dhabi, UAE
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-red-500 flex-shrink-0" />
                <a
                  href="mailto:info@total-vision.com"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  info@total-vision.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0" />
                <a
                  href="tel:+97128841675"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  +971 2 884 1675
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Total Vision. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;